/**
 * Room equipment mapping from numeric IDs to API room equipment strings
 */
export enum RoomEquipmentApiMapping {
    AirCondition = 1,
    Kitchen = 2,
    PrivateBathroom = 3,
}
